import { combineReducers } from "redux";
import { ToolDisposalSlice } from "./toolDisposalRequests/toolDisposalSlice";
import { globalSlice } from "./features/globalSlice";

export const rootReducer = combineReducers({
  global: globalSlice.reducer,
  toolDisposalSlice: ToolDisposalSlice.reducer,
});
